import { PosSettings } from "@/shared/utils/interfaces";
import usePosMenuBottomActionsHook from "@/shared/hooks/usePosMenuBottomActionsHook";

const maybeReverse = <T,>(items: T[], reverse: boolean): T[] => {
  if (reverse) {
    const reversed = [...items].reverse();
    return [...reversed.slice(1), reversed[0]];
  }
  return items;
};

type Props = {
  settings: PosSettings;
};

const PosMenuBottom = ({ settings }: Props) => {
  const { primaryActions, topActions, bottomActions } =
    usePosMenuBottomActionsHook();
  const isReversed = settings.is_cart_on_right;
  const actions = [
    primaryActions[0],
    ...maybeReverse(topActions, isReversed),
    primaryActions[1],
    ...maybeReverse(bottomActions, isReversed),
  ];

  return (
    <div className="flex h-[22vh] min-h-80 min-w-0">
      <div
        className="hidden h-full w-full min-w-0 grid-rows-2 gap-2 rounded-xl border border-border bg-tertiary-dark p-2 md:grid"
        style={{
          gridTemplateColumns: `repeat(${topActions.length + 1}, minmax(0, 1fr))`,
        }}
      >
        {actions.map((Component, i) => (
          <div key={i} className="min-h-0 min-w-0">
            {Component}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PosMenuBottom;
